<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-center">
            <b-col>        
                <b-card header="Shortcut Link to Menus">
                    <b-row>
                        <b-col class="box col-md-4 col-lg-3" v-for="(menu, idx) in menus" :key="idx">
                        <div  v-if="menu.children">
                            <h5>
                                <i :class="menu.icon"></i>
                                {{menu.title}}
                            </h5>
                            <ul>
                                <li class="sub-link" v-for="(child, idx) in menu.children" :key="idx">
                                    <router-link :to="{path:child.url}" v-if="!child.children">
                                        <i :class="child.icon"></i>
                                        {{child.title}}
                                        <span v-if="child.badge" class="badge badge-pill badge-danger">{{child.badge.text}}</span>    
                                    </router-link>
                                    
                                    <div v-if="child.children">
                                        <label>
                                            <i :class="child.icon"></i>
                                            {{child.title}}
                                        </label>
                                        <ul>
                                            <li v-for="(child1, idx) in child.children" :key="idx">
                                                <router-link :to="{path:child1.url}">
                                                    <i :class="child1.icon"></i>
                                                    {{child1.title}}
                                                    <span v-if="child1.badge" class="badge badge-pill badge-danger">{{child1.badge.text}}</span>    
                                                </router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                            </div>
                        <div v-else>
                            <router-link :to="{path:menu.url}" >
                                <i :class="menu.icon"></i>
                                {{menu.title}}
                                <span v-if="menu.badge" class="badge badge-pill badge-danger">{{menu.badge.text}}</span>    
                            </router-link>
                        </div>
                        </b-col>
                    </b-row>
                </b-card> 

            </b-col>
        </b-row>

				<b-row class="justify-content-center" style="margin-top:50px;">
            <b-col>
                <b-card>
                  <div slot="header">Todo List 
                    <div class="card-header-actions">
                        <b-pagination
                          align="right" style="margin-bottom: 0px !important;"
                          :total-rows="tblData.total"
                          :per-page="tblData.limit"
                          v-model="tblData.page"
                        ></b-pagination>
                    </div>
                  </div>

                  <div style="margin-top:10px;">
                  <b-table
                    class="mb-0"
                    ref="table"
                    outlined
                    responsive
                    striped
                    hover
                    small
                    style="font-size:smaller;"
                    :items="data"
                    :fields="tblFields"
                    :current-page="tblData.page"
                    :per-page="tblData.limit"
                    :sort-by.sync="tblData.sortBy"
                    :sort-desc.sync="tblData.sortDesc"
                    :key="tblData.limit"
                    :busy="isBusy"
                    @row-clicked="selectItem"
                    show-empty
                  >
                  <template v-slot:cell(empty)="data">
                      <h4>{{ data.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="data">
                      <h4>{{ data.emptyFilteredText }}</h4>
                    </template>
                  <template v-slot:cell(createdate)="data">
                    {{ data.item.createdate | moment("DD MMM YYYY") }}
                  </template>
                  </b-table>
                  </div>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>

<style lang="scss" scoped>
    h5 {
        i {
            margin-right: 5px;
        }
    }

    ul {
        padding-left: 0;

        .sub-link {
            display: block;
            margin-left: 10px;

            i {
                width: 20px;
            }

            li {
                display: block;
                padding-left: 20px;

                i {
                    width: 15px;
                }
            }
        }
    }
</style>


<script>
import moment from 'moment';
import toastr from "mini-toastr";
import task from "../apis/task";
import modules from "../apis/modules";
toastr.init();

export default {
  data() {
    return {
        slideImg: [1, 2, 3, 4, 5, 6, 7, 8],
      isBusy: false,
      user:this.$store.state.user,
      model: {},
      tblData: {
        items:[],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'createdate',
        sortDesc: false,
        sortDir:'asc',
        taskdetail:'',
        tgl1:moment().add(-3,'month').format('YYYY-MM-DD'),
        tgl2:moment().format('YYYY-MM-DD'),
      },
      todos:{
        items:[],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'createdate',
        sortDesc: true,
      },
      todoFields: [
          {
            key: "taskname",
            label: "Doc./Task Name",
            sortable: true
          },
          {
            key: "taskdetail",
            label: "Doc./Task Description",
          },
          {
            key: "createby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdate",
            thStyle: "width:110px",
            label: "Created @",
          },
      ],
      filter:'',
      dimCol() {
        return this.tblData.DimCol;
    	},
    };
  },  
  computed:{
    menus(){
        console.log('this.$store.state.menu',this.$store.state.menu);
      return this.$store.state.menu;
    },
		tblFields() {
      const fields= [
          {
            key: "taskname",
            thStyle: "width:300px",
            label: "Task Name",
            sortable: true
          },
          {
            key: "taskdetail",
            label: "Task Description",
          },
          {
            key: "createby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdate",
            thStyle: "width:110px",
            label: "Created At",
            sortable: true
          },
      ];
      return fields;
    },
  },
  async created() {
    // console.log('this.user',this.user)
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todos.total = filteredItems.length;
      this.todos.page = 1;
      if (this.todos.total==0) {
        this.TaskTodo();
      }
    },    
    TaskTodo:  function() {
       task.listtodo(this.todos).then((list) => {
          this.todos.items=list;
          this.todos.total = list.length;
          this.todos.page = 1;
        });
    },

    data: async function (ctx) {
      try {
        const {list,total} = await modules.listtodo(this.tblData);
        //console.log("#list: ", list);
        this.tblData.items = list;
        const this_ = this;
        setTimeout(() => {
          this_.tblData.total = total;
        }, 500);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    async refresh(ctx) {
      // this.todos.items = await this.TaskTodo();
      this.$refs.tblTaskTodo.refresh();
    },
    selectItem(item,index) {
      if (item.routeParam){
          router.push({name :item.routeName, params: JSON.parse(item.routeParam)});
      } else {
          router.push({name :item.routeName});
      }
    },  
  }  
};
</script>
